import { render, staticRenderFns } from "./EditorHeaderWrapperPPT.vue?vue&type=template&id=d26b1f24&scoped=true"
import script from "./EditorHeaderWrapperPPT.vue?vue&type=script&lang=js"
export * from "./EditorHeaderWrapperPPT.vue?vue&type=script&lang=js"
import style0 from "./EditorHeaderWrapperPPT.vue?vue&type=style&index=0&id=d26b1f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26b1f24",
  null
  
)

export default component.exports